
interface UserInfo {
  sub?: string; // User ID (e.g., "google-oauth2|106200898979288824795")
  name?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  picture?: string;
}

export const decodeJWT = (token: string): UserInfo | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export const getUserInfo = (): UserInfo | null => {
  const token = localStorage.getItem('bearer_token');
  if (!token) {
    return null;
  }
  return decodeJWT(token);
};
